var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import EEObject from "../Base/EEObject";
import GomlLoader from "../Node/GomlLoader";
import EnumConverter from "../Converters/EnumConverter";
import NumberArrayConverter from "../Converters/NumberArrayConverter";
import ComponentConverter from "../Converters/ComponentConverter";
import NumberConverter from "../Converters/NumberConverter";
import ObjectConverter from "../Converters/ObjectConverter";
import ArrayConverter from "../Converters/ArrayConverter";
import NodeInterface from "../Interface/NodeInterface";
import Utility from "../Base/Utility";
import GomlInterfaceImpl from "../Interface/GomlInterfaceImpl";
import BooleanConverter from "../Converters/BooleanConverter";
import GrimoireComponent from "../Components/GrimoireComponent";
import StringArrayConverter from "../Converters/StringArrayConverter";
import StringConverter from "../Converters/StringConverter";
import Constants from "../Base/Constants";
import ComponentDeclaration from "../Node/ComponentDeclaration";
import Component from "../Node/Component";
import NodeDeclaration from "../Node/NodeDeclaration";
import NSIdentity from "../Base/NSIdentity";
import Namespace from "../Base/Namespace";
import NSDictionary from "../Base/NSDictionary";
import Ensure from "../Base/Ensure";
export default class GrimoireInterfaceImpl extends EEObject {
    constructor() {
        super(...arguments);
        this.nodeDeclarations = new NSDictionary();
        this.converters = new NSDictionary();
        this.componentDeclarations = new NSDictionary();
        this.rootNodes = {};
        this.loadTasks = [];
        this.lib = {};
        this.nodeDictionary = {};
        this.componentDictionary = {};
        this.debug = true;
        this._registrationContext = Constants.defaultNamespace;
    }
    get initializedEventHandler() {
        return GomlLoader.initializedEventHandlers;
    }
    get callInitializedAlready() {
        return GomlLoader.callInitializedAlready;
    }
    /**
     * [obsolete] use `Namespace.define` instead of.
     * @param  {string} ns namespace URI to be used
     * @return {[type]}    the namespaced identity
     */
    ns(ns) {
        return (name) => Namespace.define(ns).for(name);
    }
    initialize() {
        this.registerConverter("String", StringConverter);
        this.registerConverter("StringArray", StringArrayConverter);
        this.registerConverter("Boolean", BooleanConverter);
        this.registerConverter(ArrayConverter);
        this.registerConverter("Object", ObjectConverter);
        this.registerConverter(EnumConverter);
        this.registerConverter("Number", NumberConverter);
        this.registerConverter(ComponentConverter);
        this.registerConverter("NumberArray", NumberArrayConverter);
        this.registerComponent(GrimoireComponent);
        this.registerNode("grimoire-node-base", ["GrimoireComponent"]);
    }
    /**
     * Register plugins
     * @param  {(}      loadTask [description]
     * @return {[type]}          [description]
     */
    register(loadTask) {
        this.loadTasks.push({ ns: this._registeringPluginNamespace, task: loadTask });
        this._registeringPluginNamespace = Constants.defaultNamespace;
    }
    resolvePlugins() {
        return __awaiter(this, void 0, void 0, function* () {
            for (let i = 0; i < this.loadTasks.length; i++) {
                const obj = this.loadTasks[i];
                this._registrationContext = obj.ns;
                try {
                    yield obj.task();
                }
                catch (e) {
                    console.error(`Error: loadTask of plugin '${obj.ns}' is failed.`);
                    console.error(e);
                }
            }
            this._registrationContext = Constants.defaultNamespace;
            // resolveDependency
            this.componentDeclarations.forEach(dec => {
                dec.resolveDependency();
            });
            this.nodeDeclarations.forEach(dec => {
                dec.resolveDependency();
            });
        });
    }
    registerComponent(arg1, arg2, arg3) {
        let name;
        let obj;
        let superComponent;
        if (typeof arg1 === "string" || arg1 instanceof NSIdentity) {
            name = arg1;
            obj = arg2;
            superComponent = arg3;
        }
        else {
            obj = arg1;
            superComponent = arg2;
            if (obj.componentName == null) {
                throw new Error(`registering component has not 'componentName': ${obj}`);
            }
            name = obj.componentName;
        }
        name = this._ensureTobeNSIdentityOnRegister(name);
        if (this.componentDeclarations.get(name)) {
            throw new Error(`component ${name.fqn} is already registerd.`);
        }
        if (typeof obj === "function" && !(obj.prototype instanceof Component)) {
            throw new Error(`component constructor ${name.fqn} must be inherits Component`);
        }
        if (this.debug && !Utility.isCamelCase(name.name)) {
            console.warn(`component ${name.name} is registerd. but,it should be 'CamelCase'.`);
        }
        const attrs = obj.attributes;
        if (!attrs) {
            throw new Error("component must has 'attributes'");
        }
        for (let key in attrs) {
            if (attrs[key].default === void 0) {
                throw new Error(`default value of attribute ${key} in ${name.fqn} must be not 'undefined'.`);
            }
        }
        const dec = new ComponentDeclaration(name, obj, superComponent);
        this.componentDeclarations.set(name, dec);
        return dec;
    }
    registerNode(name, requiredComponents = [], defaults, superNode, freezeAttributes) {
        const registerId = this._ensureTobeNSIdentityOnRegister(name);
        if (this.nodeDeclarations.get(registerId)) {
            throw new Error(`gomlnode ${registerId.fqn} is already registerd.`);
        }
        if (this.debug && !Utility.isSnakeCase(registerId.name)) {
            console.warn(`node ${registerId.name} is registerd. but,it should be 'snake-case'.`);
        }
        const declaration = new NodeDeclaration(registerId, requiredComponents || [], defaults || {}, superNode, freezeAttributes);
        this.nodeDeclarations.set(registerId, declaration);
        return declaration;
    }
    getCompanion(scriptTag) {
        const root = this.getRootNode(scriptTag);
        if (root) {
            return root.companion;
        }
        else {
            throw new Error("scriptTag is not goml");
        }
    }
    /**
     * Add specified nodes as root node managed by Grimoire.js
     * This method is typically used for internal.
     * @param tag the script element containing GOML source
     * @param rootNode root node of Goml
     */
    addRootNode(tag, rootNode) {
        if (!rootNode) {
            throw new Error("can not register null to rootNodes.");
        }
        tag.setAttribute("x-rootNodeId", rootNode.id);
        this.rootNodes[rootNode.id] = rootNode;
        rootNode.companion.set(this.ns(Constants.defaultNamespace)("scriptElement"), tag);
        // awake and mount tree.
        rootNode.setMounted(true);
        rootNode.broadcastMessage("treeInitialized", {
            ownerScriptTag: tag,
            id: rootNode.id
        });
        rootNode.sendInitializedMessage({
            ownerScriptTag: tag,
            id: rootNode.id
        });
        // send events to catch root node appended
        this.emit("root-node-added", {
            ownerScriptTag: tag,
            rootNode: rootNode
        });
        return rootNode.id;
    }
    getRootNode(scriptTag) {
        const id = scriptTag.getAttribute("x-rootNodeId");
        if (id) {
            let ret = this.rootNodes[id];
            if (!ret) {
                throw new Error(`threr is no rootNode has id ${id}`);
            }
            return ret;
        }
        else {
            return null;
        }
    }
    noConflict() {
        window["gr"] = this.noConflictPreserve;
    }
    queryRootNodes(query) {
        const scriptTags = document.querySelectorAll(query);
        const nodes = [];
        for (let i = 0; i < scriptTags.length; i++) {
            const node = this.getRootNode(scriptTags.item(i));
            if (node) {
                nodes.push(node);
            }
        }
        return nodes;
    }
    registerConverter(arg1, converter) {
        if (converter) {
            this.registerConverter({ name: this._ensureTobeNSIdentityOnRegister(arg1), verify: () => true, convert: converter });
            return;
        }
        const dec = arg1;
        this.converters.set(this._ensureTobeNSIdentityOnRegister(dec.name), dec);
    }
    overrideDeclaration(targetDeclaration, arg2, defaults) {
        const dec = this.nodeDeclarations.get(targetDeclaration);
        if (!dec) {
            throw new Error(`attempt not-exist node declaration : ${Ensure.tobeNSIdentity(targetDeclaration).name}`);
        }
        if (!dec.resolvedDependency) {
            dec.resolveDependency();
        }
        if (defaults) {
            const additionalC = arg2;
            for (let i = 0; i < additionalC.length; i++) {
                dec.addDefaultComponent(additionalC[i]);
            }
            dec.defaultAttributes.pushDictionary(Ensure.tobeNSDictionary(defaults));
        }
        else if (Array.isArray(arg2)) {
            for (let i = 0; i < arg2.length; i++) {
                dec.addDefaultComponent(arg2[i]);
            }
        }
        else {
            dec.defaultAttributes.pushDictionary(Ensure.tobeNSDictionary(arg2));
        }
        return dec;
    }
    /**
     * This method is not for users.
     * Just for unit testing.
     *
     * Clear all configuration that GrimoireInterface contain.
     */
    clear() {
        this.nodeDeclarations.clear();
        this.componentDeclarations.clear();
        this.converters.clear();
        for (let key in this.rootNodes) {
            delete this.rootNodes[key];
        }
        for (let key in this.nodeDictionary) {
            delete this.nodeDictionary[key];
        }
        for (let key in this.componentDictionary) {
            delete this.componentDictionary[key];
        }
        this.loadTasks.splice(0, this.loadTasks.length);
        this._registeringPluginNamespace = Constants.defaultNamespace;
        this.initialize();
    }
    extendGrimoireInterface(name, func) {
        if (this[name]) {
            throw new Error(`gr.${name} can not extend.it is already exist.`);
        }
        this[name] = func.bind(this);
    }
    extendGomlInterface(name, func) {
        if (GomlInterfaceImpl[name]) {
            throw new Error(`gr.${name} can not extend.it is already exist.`);
        }
        GomlInterfaceImpl[name] = func.bind(this);
    }
    extendNodeInterface(name, func) {
        if (NodeInterface[name]) {
            throw new Error(`gr.${name} can not extend.it is already exist.`);
        }
        NodeInterface[name] = func.bind(this);
    }
    /**
     * use for notify GrimoireInterface of plugin namespace to be ragister.
     * notified namespace will use when resolve loadTask of the plugin.
     * @param {string} namespace namespace of plugin to be ragister.
     */
    notifyRegisteringPlugin(namespace) {
        let res = /^[Gg]rimoire(?:js|JS)?-(.*)$/.exec(namespace);
        if (res) {
            namespace = res[1];
        }
        this._registeringPluginNamespace = namespace;
    }
    _ensureNameTobeConstructor(component) {
        if (!component) {
            return null;
        }
        if (typeof component === "function") {
            return component;
        }
        else if (typeof component === "string") {
            return this._ensureNameTobeConstructor(Ensure.tobeNSIdentity(component));
        }
        else {
            // here NSIdentity.
            let c = this.componentDeclarations.get(component);
            if (!c) {
                return null;
            }
            return c.ctor;
        }
    }
    _ensureTobeNSIdentityOnRegister(name) {
        if (!name) {
            return null;
        }
        if (typeof name === "string") {
            if (name.indexOf("|") !== -1) {
                return NSIdentity.fromFQN(name);
            }
            return NSIdentity.fromFQN(Namespace.define(this._registrationContext), name);
        }
        else {
            return name;
        }
    }
}



// WEBPACK FOOTER //
// ./src/Interface/GrimoireInterfaceImpl.ts